import React from 'react';
import { useContext } from 'use-context-selector';
import { InstantSearchList } from 'components/InstantSearchList/InstantSearchList';
import { PLPContext } from 'components/plpContext/PLPProvider';
import type { AlgoliaProductHit } from 'components/productCardHit/ProductCardHit';
import { ProductCardHit } from 'components/productCardHit/ProductCardHit';
import type { InGridContent } from 'utils/types/contentfulInGridContent';

/**
 * PLP Product Grid
 * - Component set up for displaying the Algolia Instant Search product list.
 * - Passed as a child to the PLPContent component.
 */
export const PLPProductGrid = ({
  collectionHandle,
}: {
  collectionHandle?: string;
}) => {
  const plpContext = useContext(PLPContext);

  const inGridContent: InGridContent[] = [];

  if (plpContext?.franchiseBlock) {
    inGridContent.push({
      position: 0,
      size: {
        mobile: 2,
        desktop: 1,
      },
      content: { ...plpContext.franchiseBlock },
      custom: true,
      type: 'CollectionIntroCard',
    });
  }

  const contextInGridContent = plpContext?.inGridContent || [];

  contextInGridContent.forEach((content: InGridContent) => {
    inGridContent.push(content);
  });

  return (
    <div>
      <InstantSearchList
        hitComponent={({ hit }) => (
          <ProductCardHit
            hit={hit as AlgoliaProductHit}
            collectionHandle={collectionHandle}
          />
        )}
        itemClassName="col xs2 l3"
        inGridContent={inGridContent}
        collectionHandle={collectionHandle}
      />
    </div>
  );
};
